import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from 'src/app/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
declare let $: any;

@Component({
  selector: 'app-license-summary',
  templateUrl: './license-summary.component.html',
  styleUrls: ['./license-summary.component.scss']
})

export class LicenseSummaryComponent implements OnInit {
  totalDeviceCount: number;
  constructor(
    private _formBuilder: FormBuilder,
    private _service: ApiService,
    private _toastr: ToastrService,
    private _translate: TranslateService,
    private _actRoute: ActivatedRoute
  ) {
    this._translate.get('ACTIVITYHISTORY.ALLUSERS')
      .subscribe(value => {
        this.allUserStr = value;
      });
  }
  selectedLanguage: string = '';
  isDeviceRemoved: boolean = false;
  txt_color: String = '#721C24';
  bg_badge_clr: String = '#FFDDDD';
  getMyDeviceData: any;
  isLoading: boolean = false;
  getMyUseDeviceData: any;
  showMyUserDeviceData: any;
  selectedMyLicenseIndex: number = 0;
  selectedUserLicenseIndex: number = 0;
  getMyIndexData: any;
  getUserIndexData: any;
  openMyLicense: boolean = false;
  selectedMyLicenseId: string = '';
  selectedUserLicenseId: string = '';
  openUserLicense: boolean = false;
  myLicenseList: any;
  myUserCount: number = 0;
  myCount: number = 0;
  totalNumberOfDevices: any = [];
  myUserLicenseList: any;
  activeTab: boolean = true;
  activeUserTab: boolean = true;
  renewURL: string;
  allUserLicense: any;
  expDays: any;
  allUserStr: string = '';
  userResponse: any = [{ id: '', name: this.allUserStr }];
  userSelected: string = '';
  userTimezone: string;
  crwSupportedProductTypes: string[] = [
    'QH_LITE',
    'QH_IS_ESSENTIAL',
    'QH_PLUS',
    'QH_TS',
  ];

  ngAfterViewInit() {
    this.selectedMyLicenseIndex = 0;
    this.selectedUserLicenseIndex = 0;
    this.showMyUserDeviceData = this.getMyUseDeviceData;
  }
  userId: any;
  loggedInUser: any;
  ngOnInit(): void {
    this.userId = this._actRoute.snapshot.params['id'];

    scrollTo(0, 0);
    this.selectedMyLicenseIndex = 0;
    this.selectedUserLicenseIndex = 0;
    let selectedLangStringValue = localStorage.getItem('selectedLang');
    if (selectedLangStringValue) {
      this.selectedLanguage = selectedLangStringValue;
      this._translate.use(this.selectedLanguage);
    }
    let currentUser = localStorage.getItem('currentUser');
    if (currentUser) {
      this.loggedInUser = JSON.parse(currentUser);
    }
    this.openMyLicense = true;

    // Get user's timezone
    this.userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'; // Fallback to UTC if not available
    this.getAllUserLicense();
    this.showMyUserDeviceData = this.getMyUseDeviceData;
    if (this.userId === undefined) {
      this.getAllMyLicense();
    }
  }

  // Remove License Logic is here
  removeLicenseId: any;
  openRemoveLicensePopup(data: any) {
    this.isDeviceRemoved = false;

    this.removeLicenseId = data;
    $('#removeLicensePopup').modal('show');
  }

  onRemoveDevice() {
    try {
      this.isDeviceRemoved = false;
      this._service
        .deleteService(
          this._service.API_URL.removeLicense + this.removeLicenseId
        )
        .subscribe((response: any) => {
          if (response.status.code === 200) {
            this.isDeviceRemoved = true;
            this.getAllMyLicense();
          } else {
            this.isDeviceRemoved = false;
            this._toastr.error('', response.status.message);
          }
        });
    } catch (error) { }
  }

  // Fetching Data for My Device License Summary

  selectedMyIndex(index: any, data: any) {
    this.totalNumberOfDevices = [];
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.getMyIndexData = data;
    this.selectedMyLicenseIndex = index;
    this.selectedMyLicenseId = data.id;
    if (this.selectedMyLicenseId == data.id) {
      this.activeTab = true;
    } else {
      this.activeTab = false;
    }
    if (this.getMyIndexData.productKeyType === 'FAMILY_PACK') {
      for (let i = 1; i <= this.getMyIndexData.totalNumberOfDevices; i++) {
        let isSelected: boolean =
          i <= this.getMyIndexData.availableUsedKeys ? true : false;
        this.totalNumberOfDevices.push({ isSelected: isSelected });
      }
      this.getFamilyPackData(this.getMyIndexData.productKey);
    } else if (this.getMyIndexData.productKeyType === 'SYSTEM') {
      this.getLicenseHistory(this.getMyIndexData.productKey);
    }
  }

  getDate(val: string) {
    if (!val) {
      return '';
    }
    let a = val.split(' ');
    return a[0];
  }

  getAllMyLicense() {
    let apiUrl;
    try {
      this.isLoading = true;
      if (this.userId === undefined) {
        apiUrl = `${this._service.API_URL.getAllMyLicense}?timezone=${encodeURIComponent(this.userTimezone)}&selectedLang=${encodeURIComponent(this.selectedLanguage)}`;
      } else {
        apiUrl = `${this._service.API_URL.getAllMyLicense}?userId=${encodeURIComponent(this.userId)}&timezone=${encodeURIComponent(this.userTimezone)}&selectedLang=${encodeURIComponent(this.selectedLanguage)}`;
      }
      this._service.getService(apiUrl).subscribe((response) => {
        if (response.data && response.status.code === 200) {
          this.getMyDeviceData = response.data?.myLicenseList;
          this.myUserCount = response.data?.myUserCount;
          this.isLoading = false;
          this.myCount = response.data?.myLicenseList?.length;
          if (this.getMyDeviceData && this.selectedMyLicenseIndex == 0) {
            this.getMyIndexData = response.data?.myLicenseList[0];
            this.selectedMyLicenseId = this.getMyIndexData?.id;
            this.totalNumberOfDevices = [];
            if (this.getMyIndexData.productKeyType === 'FAMILY_PACK') {
              for (
                let i = 1;
                i <= this.getMyIndexData?.totalNumberOfDevices;
                i++
              ) {
                let isSelected: boolean =
                  i <= this.getMyIndexData.availableUsedKeys;
                this.totalNumberOfDevices.push({ isSelected: isSelected });
              }
              this.getFamilyPackData(this.getMyIndexData.productKey);
            } else if (this.getMyIndexData.productKeyType === 'SYSTEM') {
              this.getLicenseHistory(this.getMyIndexData?.productKey);
            }
          }
        }
      });
    } catch (error) {
      this.isLoading = false;
    }
  }

  // Fetching Data for User Device License Summary

  selectedUserIndex(index: any, data: any) {
    this.totalNumberOfDevices = [];
    this.getUserIndexData = data;
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.selectedUserLicenseId = data.id;
    if (this.selectedUserLicenseId == data.id) {
      this.activeUserTab = true;
    } else {
      this.activeUserTab = false;
    }
    let isSelected: boolean;
    if (this.getUserIndexData.productKeyType === 'FAMILY_PACK') {
      for (let i = 1; i <= this.getUserIndexData.totalNumberOfDevices; i++) {
        isSelected = i <= this.getUserIndexData.availableUsedKeys;
        this.totalNumberOfDevices.push({ isSelected: isSelected });
      }
      this.getFamilyPackData(this.getUserIndexData.productKey);
    } else if (this.getUserIndexData.productKeyType === 'SYSTEM') {
      this.getLicenseHistory(this.getUserIndexData.productKey);
    }
  }

  //  On this Click we are opening the tabs (My Device) Or (Users Device)
  // openTabs(deviceType: any) {
  //   if (deviceType === 'MYLICENSE') {
  //     this.openMyLicense = true;
  //     this.openUserLicense = false;
  //     this.getAllMyLicense();
  //   } else if (deviceType === 'USERLICENSE') {
  //     this.openUserLicense = true;
  //     this.openMyLicense = false;
  //     this.getAllUserLicense();
  //     this.getAllMyLicense();
  //     this.myUserLicenseList.add(this.getMyDeviceData);
  //     console.log(this.myUserLicenseList);

  //   }

  // }
  getAllUserLicense() {
    let apiUrl: any;
    try {
      this.isLoading = true;
      if (this.userId === undefined) {
        apiUrl = `${this._service.API_URL.getAllUserLicense}?timezone=${encodeURIComponent(this.userTimezone)}&selectedLang=${encodeURIComponent(this.selectedLanguage)}`;
      } else {
        apiUrl = `${this._service.API_URL.getAllUserLicense}?userId=${this.userId}&timezone=${encodeURIComponent(this.userTimezone)}`;
      }
      this._service.getService(apiUrl).subscribe((response) => {
        if (response.data && response.status.code === 200) {
          this.isLoading = false;
          if (this.userId && this.userId !== undefined) {
            this.myCount = response.data.myCount;
          }
          this.getMyUseDeviceData = response.data.myUserLicenseList;
          this.userResponse = this.getMyUseDeviceData.slice();
          this.userResponse.push({ id: '', name: this.allUserStr });
          this.userSelected = '';
          this.totalDeviceCount = 0;
          response.data.myUserLicenseList.forEach((element: any) => {
            this.myUserLicenseList = element?.myUserLicenseList;
            this.totalDeviceCount += element?.myUserLicenseList.length;
          });
          this.showMyUserDeviceData = this.getMyUseDeviceData;
          if (this.getMyUseDeviceData && this.selectedUserLicenseIndex == 0) {
            this.getUserIndexData =
              this.getMyUseDeviceData[0].myUserLicenseList[0];
            this.selectedUserLicenseId = this.getUserIndexData?.id;
            this.totalNumberOfDevices = [];
            if (this.getUserIndexData.productKeyType === 'FAMILY_PACK') {
              for (
                let i = 1;
                i <= this.getUserIndexData?.totalNumberOfDevices;
                i++
              ) {
                let isSelected: boolean =
                  i <= this.getUserIndexData.availableUsedKeys;
                this.totalNumberOfDevices.push({ isSelected: isSelected });
              }
              this.getFamilyPackData(this.getUserIndexData.productKey);
            } else if (this.getUserIndexData.productKeyType === 'SYSTEM') {
              this.getLicenseHistory(this.getUserIndexData.productKey);
            }
          }
          this.myUserCount = response.data.myUserCount;
        }
      });
    } catch (error) { }
  }

  getAllUserLicenseUser(data: any) {
    let apiUrl: any;
    try {
      this.isLoading = true;
      apiUrl = this._service.API_URL.getAllUserLicense + '?userId=' + data;
      this._service.getService(apiUrl).subscribe((response) => {
        if (response.data && response.status.code === 200) {
          this.isLoading = false;
          if (this.userId && this.userId !== undefined) {
            this.myCount = response.data.myCount;
          }
          this.getMyUseDeviceData = response.data.myUserLicenseList;
          this.userResponse = this.getMyUseDeviceData.slice();
          this.userResponse.push({ id: '', name: this.allUserStr });
          this.totalDeviceCount = 0;
          response.data.myUserLicenseList.forEach((element: any) => {
            this.myUserLicenseList = element?.myUserLicenseList;
            this.totalDeviceCount += element?.myUserLicenseList.length;
          });
          this.showMyUserDeviceData = this.getMyUseDeviceData;

          if (this.getMyUseDeviceData && this.selectedUserLicenseIndex == 0) {
            this.getUserIndexData =
              this.getMyUseDeviceData[0].myUserLicenseList[0];
            this.selectedUserLicenseId = this.getUserIndexData?.id;
            this.totalNumberOfDevices = [];
            if (this.getUserIndexData.productKeyType === 'FAMILY_PACK') {
              for (
                let i = 1;
                i <= this.getUserIndexData?.totalNumberOfDevices;
                i++
              ) {
                let isSelected: boolean =
                  i <= this.getUserIndexData.availableUsedKeys;
                this.totalNumberOfDevices.push({ isSelected: isSelected });
              }
              this.getFamilyPackData(this.getUserIndexData.productKey);
            } else if (this.getUserIndexData.productKeyType === 'SYSTEM') {
              this.getLicenseHistory(this.getUserIndexData.productKey);
            }
          }
          this.myUserCount = response.data.myUserCount;
        }
      });
    } catch (error) { }
  }
  onfilterChange(data: any) {
    if (data === '') {
      this.showMyUserDeviceData = this.getMyUseDeviceData;
      this.getUserIndexData = this.showMyUserDeviceData[0].myUserLicenseList[0];
      this.selectedUserLicenseId = this.getUserIndexData?.id;
    } else {
      this.showMyUserDeviceData = this.getMyUseDeviceData.filter(
        (myUserLicenseList: { id: any }) => myUserLicenseList.id === data
      );
      this.getUserIndexData = this.showMyUserDeviceData[0].myUserLicenseList[0];
      this.selectedUserLicenseId = this.getUserIndexData?.id;
    }
  }

  openMyIndexRenewLicense(data: any, type?: string) {
    let prdkey = '';
    let url = '';
    if (this.userTimezone == 'Asia/Kolkata' || this.userTimezone == 'Asia/Calcutta') {
      if (this.selectedLanguage && this.selectedLanguage !== 'en') {
        prdkey = this.crwSupportedProductTypes.includes(data?.productType) ? data.productKey : '';
        url = `${data.productLink}?prdkey=${prdkey}&QVER=${data.buildVersion}`;
      } else {
        prdkey = this.crwSupportedProductTypes.includes(data?.productType)
          ? data.encryptedProductKey : data.productKey;
        url = `${data.productLink}?prdkey=${prdkey}`;
      }
    } else {
      prdkey = this.crwSupportedProductTypes.includes(data?.productType) ? data.productKey : '';
      url = `${data.productLink}?prdkey=${prdkey}&QVER=${data.buildVersion}`;
    }
    const newTab = window.open(url, '_blank');

    const messageHandler = (event: MessageEvent) => {
      if (event.origin !== data.crwDomainUrl) return;

      if (event.data === 'payment_success') {
        window.removeEventListener('message', messageHandler);
        this.handlePaymentSuccess(data.productKey);
      } else {
        window.removeEventListener('message', messageHandler);
      }
    };

    window.addEventListener('message', messageHandler);
    // Poll to detect if the user closes the tab without completing payment
    const tabWatcher = setInterval(() => {
      if (newTab?.closed) {
        clearInterval(tabWatcher);
        window.removeEventListener('message', messageHandler);
      }
    }, 500); // Check every 500ms
  }

  handlePaymentSuccess(productKey: string): void {
    this.getDesktopProductKeyDetails(productKey, 'userIndex');
    // Update license list or redirect
  }

  getDesktopProductKeyDetails(productKey: string, userIndex: string): void {
    this.isLoading = true;
    try {
      this._service
        .getService(
          this._service.API_URL.getDesktopProductKeyDetails +
          '?productKey=' +
          productKey
        )
        .subscribe((response) => {
          if (response && response.status.code === 200) {
            this.isLoading = false;
            if (userIndex == 'userIndex') {
              if (response.data.expiryDate != null) {
                this.getUserIndexData.licenseValidityDate = response.data.expiryDate;
              }
              if (response.data.activationDate != null) {
                this.getUserIndexData.activationDate = response.data.activationDate;
              }
              if (response.data.autoRenewal != null) {
                this.getUserIndexData.autoRenewal = response.data.autoRenewal;
              }
              if (response.data.buildVersion != null) {
                this.getUserIndexData.buildVersion = response.data.buildVersion;
              }
              if (response.data.productName != null) {
                this.getUserIndexData.productName = response.data.productName;
              }
            } else {
              if (response.data.expiryDate != null) {
                this.getMyIndexData.licenseValidityDate = response.data.expiryDate;
              }
              if (response.data.activationDate != null) {
                this.getMyIndexData.activationDate = response.data.activationDate;
              }
              if (response.data.autoRenewal != null) {
                this.getMyIndexData.autoRenewal = response.data.autoRenewal;
              }
              if (response.data.buildVersion != null) {
                this.getMyIndexData.buildVersion = response.data.buildVersion;
              }
              if (response.data.productName != null) {
                this.getMyIndexData.productName = response.data.productName;
              }
            }
            // this.getAllUserLicense();
          }
        });
    } catch (error) {
      console.log(error);
    }
  }

  getMobileProductKeyDetails(deviceId: string, userIndex: string): void {
    this.isLoading = true;
    try {
      this._service
        .getService(
          this._service.API_URL.getMobileProductKeyDetails +
          '?deviceId=' +
          deviceId
        )
        .subscribe((response) => {
          if (response && response.status.code === 200) {
            if (userIndex === 'myIndexData') {
              if (response.data.expiryDate != null) {
                this.getMyIndexData.licenseValidityDate = response.data.expiryDate;
              }
              if (response.data.activationDate != null) {
                this.getMyIndexData.activationDate = response.data.activationDate;
              }
              if (response.data.autoRenewal != null) {
                this.getMyIndexData.autoRenewal = response.data.autoRenewal;
              }
              if (response.data.buildVersion != null) {
                this.getMyIndexData.buildVersion = response.data.buildVersion;
              }
              if (response.data.productName != null) {
                this.getMyIndexData.productName = response.data.productName;
              }

            } else {

              if (response.data.expiryDate != null) {
                this.getUserIndexData.licenseValidityDate = response.data.expiryDate;
              }
              if (response.data.activationDate != null) {
                this.getUserIndexData.activationDate = response.data.activationDate;
              }
              if (response.data.autoRenewal != null) {
                this.getUserIndexData.autoRenewal = response.data.autoRenewal;
              }
              if (response.data.buildVersion != null) {
                this.getUserIndexData.buildVersion = response.data.buildVersion;
              }
              if (response.data.productName != null) {
                this.getUserIndexData.productName = response.data.productName;
              }
            }

            this.isLoading = false;
            // this.getAllDevice();
          } else {
            this.isLoading = false;
          }
        });
    } catch (error) {
      this.isLoading = false;
      console.log(error);
    }
  }

  licenseHistoryRecords: any[] = [];
  getLicenseHistory(productData: any) {
    let a = [];
    let checkOne, checkTwo, changedFormat;
    this.licenseHistoryRecords = [];
    try {
      this._service
        .getService(
          this._service.API_URL.getLicenseHistory + '?productKey=' + productData
        )
        .subscribe((response) => {
          if (response && response.status.code === 200) {
            this.licenseHistoryRecords = response.data?.licenseHistoryRecords;
            this.licenseHistoryRecords.forEach((res: any) => {
              checkOne = res.activityActionMessage.split(
                '<span class=istTimeFromMillisec>'
              );
              checkTwo = checkOne[1].split('</span>');
              checkTwo[0] = Number(checkTwo[0]);
              changedFormat = moment(new Date(checkTwo[0])).format(
                'DD/MM/YYYY HH:mm:ss'
              );
              res.activityActionMessage =
                checkOne[0] + changedFormat + checkTwo[1];
            });
          }
        });
    } catch (error) { }
  }

  checkBeforeRenew(data: any) {
    if (data === 'MOBSEC_ADVANCE') {
      $('#renewPopup').modal('show');
    } else {
      this.openMyIndexRenewLicense(this.getUserIndexData);
    }
  }

  getProductKeyType: string = '';
  getFamilyPackData(id: any) {
    this._service
      .getService(this._service.API_URL.getFamilyPackData + id)
      .subscribe((response) => {
        if (response && response.status.code === 200) {
          this.licenseHistoryRecords = response.data;
          response.data.forEach((element: any) => {
            this.getProductKeyType = element.productKeyType;
          });
        }
      });
  }
}
